import { GraphQLClient } from 'graphql-request';
import { GRAPHQL_URI, DEFAULT_PRICE_MODEL } from '@config/constants';
import { SiteConfig } from '@utils';

export const createGraphQLClient = () => {
  const { pricingDeterminationModel, locale, siteId } = SiteConfig.getConfig();
  return new GraphQLClient(GRAPHQL_URI!, {
    headers: () => ({
      'X-Viax-User-Locale': locale || '',
      'x-viax-user-website': siteId,
      'x-viax-user-pricing-model': pricingDeterminationModel || DEFAULT_PRICE_MODEL,
    }),
  });
};

const getClient = (() => {
  let instance: GraphQLClient | null = null;
  return () => {
    if (!instance) {
      instance = createGraphQLClient();
    }
    return instance;
  };
})();

export { getClient };

export const client = new Proxy({} as GraphQLClient, {
  get(_target, prop) {
    return getClient()[prop as keyof GraphQLClient];
  },
});
